<template lang="html">
  <div style="height: 1px; width: 1px;"></div>
</template>

<script lang="js">
export default {
  name: 'app-header'
}
</script>

<style scoped lang="scss">
.app-footer {

}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppHeader.vue